if (!window.Eurus.loadedScript.includes('sealer-popup.js')) {
  window.Eurus.loadedScript.push('sealer-popup.js');

  document.addEventListener('alpine:init', () => {
    Alpine.data('sealerPopup', () => ({
      showPopup: false,
      loading: false,
      bundlePrice: '$0.00',
      bundleVariantId: null,
      bundleHandle: 'poseidons-tile-primer-and-zeus-tile-sealer',
      bundleImage: null,
      bundleTitle: 'Poseidon\'s Tile Primer & Zeus Tile Sealer Bundle',
      
      init() {
        // Listen for box:added events
        document.addEventListener('box:added', (e) => {
          this.handleBoxAdded(e);
        });
        
        // Fetch bundle product data on init
        this.fetchBundleData();
      },
      
      async fetchBundleData() {
        try {
          const response = await fetch(`/products/${this.bundleHandle}.js`);
          if (response.ok) {
            const product = await response.json();
            if (product && product.variants && product.variants.length > 0) {
              this.bundleVariantId = product.variants[0].id;
              this.bundlePrice = this.formatPrice(product.variants[0].price);
              this.bundleTitle = product.title || this.bundleTitle;
              this.bundleImage = product.featured_image || (product.images && product.images[0]);
            }
          } else {
            // If product doesn't exist, don't set any values - popup won't show
            console.warn('Bundle product not found, sealer popup will not show');
          }
        } catch (error) {
          console.warn('Could not fetch sealer bundle product data, sealer popup will not show:', error);
        }
      },
      
      handleBoxAdded(event) {
        // Only show popup if we have a valid bundle variant ID
        if (!this.bundleVariantId) {
          console.log('Sealer popup skipped: bundle product not available');
          return;
        }
        
        // Wait 1.5 seconds before showing popup as per requirements
        setTimeout(() => {
          this.showPopup = true;
        }, 1500);
      },
      
      async addToCart() {
        if (!this.bundleVariantId) {
          console.error('Bundle variant ID not available');
          return;
        }
        
        this.loading = true;
        
        try {
          const formData = new FormData();
          formData.append('id', this.bundleVariantId);
          formData.append('quantity', 1);
          
          // Add sections if cart helper is available
          if (Alpine.store('xCartHelper') && Alpine.store('xCartHelper').getSectionsToRender) {
            formData.append('sections', Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id));
            formData.append('sections_url', window.location.pathname);
          }
          
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 
              'Accept': 'application/javascript', 
              'X-Requested-With': 'XMLHttpRequest' 
            },
            body: formData
          });
          
          if (response.ok) {
            const result = await response.json();
            
            // Update cart sections if cart helper is available
            if (result.sections && Alpine.store('xCartHelper') && Alpine.store('xCartHelper').getSectionsToRender) {
              Alpine.store('xCartHelper').getSectionsToRender().forEach((section => {
                const sectionElement = document.querySelector(section.selector);
                if (sectionElement && result.sections[section.id] && typeof getSectionInnerHTML === 'function') {
                  sectionElement.innerHTML = getSectionInnerHTML(result.sections[section.id], section.selector);
                }
              }));
            }
            
            // Update cart count
            const cartBubble = document.querySelector('#cart-icon-bubble span');
            if (cartBubble && Alpine.store('xCartHelper')) {
              Alpine.store('xCartHelper').currentItemCount = parseInt(cartBubble.innerHTML);
            }
            
            // Dispatch cart events
            document.dispatchEvent(new CustomEvent("ajaxProduct:added", {
              detail: result
            }));
            document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
            
            // Show cart notification if enabled
            if (Alpine.store('xCartNoti') && Alpine.store('xCartNoti').enable) {
              Alpine.store('xCartNoti').setItem(result); 
            }
            
            this.closePopup();
          } else {
            console.error('Failed to add bundle to cart');
          }
        } catch (error) {
          console.error('Error adding bundle to cart:', error);
        } finally {
          this.loading = false;
        }
      },
      
      closePopup() {
        this.showPopup = false;
      },
      
      formatPrice(cents) {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD'
        }).format(cents / 100);
      }
    }));
  });
}